import { RPInstance } from './base';
import store from '@/store';

const pointApi = {};

const getBaseUrl = () => {
  const serviceUrl = store.getters['serviceUrl'];
  return `${serviceUrl}/point`;
};

pointApi.getPointInfo = () => {
  const baseUrl = getBaseUrl();
  return RPInstance.get(baseUrl);
};

// 포인트 (적립) 내역
pointApi.getPointHistory = (val) => {
  const baseUrl = getBaseUrl();
  const params = {
    ...val,
    pointStatus: val.pointStatus + 1,
  };
  return RPInstance.get(`${baseUrl}/history`, { params });
};

export default {
  ...pointApi,
};
